import { useState } from 'react';
import { auth } from '../../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { Link, useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSignInSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    signInWithEmailAndPassword(auth, email, pass)
      .then((res) => {
        setError("");
        setLoading(false);
        if (res.user.emailVerified) {
          navigate("/account");
        } else {
          setError("Please verified your email before login.");
        }
      }).catch((error) => {
        setMsg("");
        setError("Invalid username or password");
        setLoading(false);
      });
  }

  return (

    <section id="contact" className="contact">
      <div className="container " data-aos="fade-down">
        <div className="login-title mt-3">
          <h2>Sign In </h2>
        </div>
      </div>

      <div className="row " style={{ justifyContent: "center" }}>
        <div className="col-lg-4 mt-5 mt-lg-0 d-flex align-items-stretch" data-aos="fade-up" data-aos-delay={200}>
          <div className="php-email-form" >
            <form onSubmit={onSignInSubmit}>
              <div className="row text-align-center">
                <div className="form-group col-md-12">
                  <input type="email" name="email" className="form-control mb-2" readOnly={loading} value={email}
                    onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Email Id" required />
                </div>
                <div className="form-group col-md-12">
                  <input type="password" name="password" className="form-control mb-2" readOnly={loading}
                    onChange={(e) => setPass(e.target.value)} value={pass} id="pass" placeholder="Password" required />
                </div>
                <div className="form-group col-md-12">
                  <button type="submit" disabled={!email || loading || !pass}>Submit</button>
                </div>
              </div>
            </form>
            {msg && <div className="alert alert-success" role="alert">{msg}</div>}
            {error && <div className="alert alert-danger" role="alert">{error}</div>}
            <Link to="/forgetPassword" style={{color:'grey', fontSize:'small'}}>Forget Password</Link><br/>
            <div className='mt-2'>
              
              <Link to="/signup">Create a new account</Link>
            </div>
          </div>
        </div>
        <div id="sign-in-button"></div>
      </div>
    </section>
  );
}